import GlobalConfigActionConstants from "./GlobalConfigActionsConstants.js";
function loadingControlTowerExperience() {
  return {
    type: GlobalConfigActionConstants.LOADING_CONTROL_TOWER_EXPERIENCE
  };
}
function loadedControlTowerExperience(controlTowerExperienceConfig) {
  return {
    type: GlobalConfigActionConstants.LOADED_CONTROL_TOWER_EXPERIENCE,
    payload: controlTowerExperienceConfig
  };
}
export {
  loadedControlTowerExperience,
  loadingControlTowerExperience
};
//# sourceMappingURL=GlobalConfigActions.js.map
